import React, { useEffect, useState } from "react";
import { getCurrencySymbol } from "../../features/utils/countires";
import { formatMoney } from "../../features/utils/formatMoney";
import CommonDropdownInput from "./inputs/CommonDropdownInput";
import CommonFreeTextInput from "./inputs/CommonFreeTextInput";

const initData = {
  variant: "Markup",
  type: "Fixed",
  amount: "",
};

const options = {
  variant: ["Markup", "Markdown"],
  type: ["Fixed", "Percentage"],
};

export default function CommonFlexMarkup({ amount = 0, callback }) {
  const [total, setTotal] = useState(amount);
  const [data, setData] = useState(initData);

  useEffect(() => {
    setTotal(amount);
    setData(initData);
  }, [amount]);

  useEffect(() => {
    handleChange();
  }, [data]);

  useEffect(() => {
    setData({ ...data, amount: "" });
  }, [data.variant, data.type]);

  useEffect(() => {
    switch (data.variant) {
      case "Markup":
        switch (data.type) {
          case "Percentage":
            break;
          default:
            break;
        }
        break;
      case "Markdown":
        switch (data.type) {
          case "Fixed":
            if (Number(data.amount) > amount)
              setData({ ...data, amount: amount });
            break;
          case "Percentage":
            if (Number(data.amount) > 100) setData({ ...data, amount: 100 });
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
  }, [data.amount]);

  useEffect(() => {
    callback?.({
      total,
      markup: total - amount,
    });
  }, [total]);

  function handleChange() {
    let value = null;
    if (data?.type === "Fixed") value = Number(data?.amount);
    else value = Number(amount) * (Number(data?.amount) / 100);

    if (data?.variant === "Markup") value += Number(amount);
    else value = Number(amount) - value;

    setTotal(value);
  }

  const overAllTotal = total;

  return (
    <div className="flex gap-2">
      <div className="flex flex-col gap-1 flex-1">
        <div className="flex gap-2 items-center flex-col lg:flex-row">
          <CommonDropdownInput
            label="Type"
            className="lg:!w-[150px]"
            options={options.variant}
            value={data.variant}
            onChange={(value) => {
              setData({ ...data, variant: value });
            }}
          />
          <CommonDropdownInput
            label={`${data.variant} type`}
            className="lg:!w-[150px]"
            options={options.type}
            value={data.type}
            onChange={(value) => {
              setData({ ...data, type: value });
            }}
          />
          <CommonFreeTextInput
            label={`Amount (${
              data.type === "Fixed" ? getCurrencySymbol("NGN") : "%"
            })`}
            value={data.amount}
            onChange={(value) => {
              const digitsOnly = value.replace(/\D/g, "");
              setData({ ...data, amount: digitsOnly });
            }}
          />
        </div>

        <div className="flex justify-between gap-4 items-center">
          <span className={`block text-sm mb-1 text-gray-600`}>
            New Trip Total
          </span>
          <span className={`block text-lg font-bold mb-1 text-gray-600`}>
            {formatMoney(overAllTotal)}
          </span>
        </div>
      </div>
    </div>
  );
}
